const initialBudgetVsActualState = {
  loading: false,
  data: null,
  error: null,
};

export const projectCostBudgetVsActualReducer = (state = initialBudgetVsActualState, action) => {
  switch (action.type) {
    case "GET_PROJECT_COST_BUDGET_VS_ACTUAL_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_PROJECT_COST_BUDGET_VS_ACTUAL_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_PROJECT_COST_BUDGET_VS_ACTUAL_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialGranularState = {
  loading: false,
  data: null,
  error: null,
};

export const projectCostGranularReducer = (state = initialGranularState, action) => {
  switch (action.type) {
    case "GET_PROJECT_COST_GRANULAR_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_PROJECT_COST_GRANULAR_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_PROJECT_COST_GRANULAR_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialOverrunsState = {
  loading: false,
  data: null,
  error: null,
};

export const projectCostOverrunsReducer = (state = initialOverrunsState, action) => {
  switch (action.type) {
    case "GET_PROJECT_COST_OVERRUNS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_PROJECT_COST_OVERRUNS_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_PROJECT_COST_OVERRUNS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
